import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useRef, useState} from 'react';
import {hideLoader, showLoader} from '../../store/common/slice';
import {getBase64} from '../shared/statelessMethods';
import {PrintSection} from './components.styled';
import ReactHtmlParser from 'react-html-parser';
import {getUserProfile} from '../../store/auth/actions';

export default function PdfWrapper({component, onSavePdf}) {
    const dispatch = useDispatch();
    const pdf = useRef();
    const userProfile = useSelector(state => state.auth.userProfile);
    const [partnerLogo, setPartnerLogo] = useState('');
    const [bllinkLogoBase64, setBllinkLogoBase64] = useState(null);

    useEffect(async () => {
        if (bllinkLogoBase64 == null) {
            // load dynamically to exclude from common bundle
            const module = await import('../shared/bllinkLogoBase64');
            setBllinkLogoBase64(module.bllinkLogoBase64);
        }
    });

    useEffect(() => {
        (async function () {
            dispatch(showLoader());
            // bug fixed. some users are created with an empty first name so this created an endless loop
            if (userProfile.userID === undefined) {
                await dispatch(getUserProfile());
            }
            dispatch(hideLoader());
        })();
    }, [component, userProfile]);

    useEffect(() => {
        (async function () {
            // bug fixed. some users are created with an empty first name so this created an endless loop
            if (userProfile?.userID) {
                const image = await getBase64(userProfile.partnerLogo || '');
                setPartnerLogo(`${image ? `data:image/png;base64,${image}` : ''}`);
                await onSavePdf(pdf.current);
            }
        })();
    }, [userProfile]);

    return (
        <PrintSection>
            <div ref={pdf} className='table-container'>
                <div className='logos'>
                    <div className='logo-top'>
                        <img src={bllinkLogoBase64} alt="company logo"/>
                    </div>
                    <div className={`logo-top partner ${partnerLogo ? '' : 'empty'}`}>
                        <img src={partnerLogo} alt="partner logo"/>
                    </div>
                </div>
                {ReactHtmlParser(component.innerHTML)}
            </div>
        </PrintSection>
    );
}
